import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Linking, Image, ScrollView } from 'react-native';
import { WebView } from 'react-native-webview';
import { Feather } from '@expo/vector-icons';
import styles from './styles/styles';  // Import the styles
import Sidebar from './sidebar';  // ✅ Import the new Sidebar
import Footer from './footer'; // ✅ Import Footer
import Header from './header'; // ✅ Import Footer

const Contact = ({ navigation }) => {

  const [activeLink, setActiveLink] = useState('Contact');

  const [showSidebar, setShowSidebar] = useState(false);

  const handleLinkPress = (screen) => {
    setShowSidebar(false); // Close sidebar on navigation
    navigation.navigate(screen);
  };

   const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };



const openInMaps = (lat, lon) => {
  const url = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}#map=18/${lat}/${lon}`;
  Linking.openURL(url).catch((err) =>
    console.error('Failed to open OpenStreetMap:', err)
  );
};



const locations = [
  {
    label: 'California',
    address: '216 Valley Creek Lane #F, Danville, CA 94526, USA',
    lat: 37.8216,
    lon: -121.9905,
  },
  {
    label: 'Nevada',
    address: '732 S 6th ST, STE N, Las Vegas, NV 89101, USA         ',
    lat: 36.1619,
    lon: -115.1398,
  },
];



  return (
    <View style={styles.pageContainer}>
       {/* Fixed Header */}
      <View style={styles.fixedHeader}>
         <Header onToggleSidebar={toggleSidebar} />
      </View>

      {showSidebar && (
        <Sidebar
          activeLink={activeLink}
          handleLinkPress={handleLinkPress}
          onClose={() => setShowSidebar(false)}
        />
      )}

      {/* Scrollable Content */}
      <ScrollView contentContainerStyle={styles.scrollContainer}>

      {/* Main Content */}
      <View style={styles.mainContent}>
        <Text style={styles.heading}>Contact Us</Text>

        
        
         <View style={{ height: 20 }} /> 
      
         <View style={styles.imageWrapper}>
        <Image
          source={require('./assets/contactus.png')}
          style={styles.storyImage}
          resizeMode="cover"
        />
      </View>
      
       <View style={{ height: 20 }} />

    <View style={styles.contactDetails}>
      <Text style={styles.contactText}>
        Email: <Text style={styles.contactText}>info@integrationx.ai</Text>
      </Text>


      {locations.map((loc, idx) => {
        //const mapUrl = `https://staticmap.openstreetmap.de/staticmap.php?center=${loc.lat},${loc.lon}&zoom=15&size=400x200&markers=${loc.lat},${loc.lon}`;
        const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${loc.lon - 0.01}%2C${loc.lat - 0.01}%2C${loc.lon + 0.01}%2C${loc.lat + 0.01}&layer=mapnik&marker=${loc.lat}%2C${loc.lon}`;

        console.log(mapUrl);  // Check the generated URL in the console
        return (
          <View key={idx} style={{ marginTop: 20 }}>
            <Text style={[styles.contactText, styles.addressText]}>
              📍 {loc.label}: {loc.address}
            </Text>
           <TouchableOpacity onPress={() => openInMaps(loc.lat, loc.lon)}>
            <View style={{ height: 20 }} />
           <View style={{ height: 200, width: '100%' }}>
            <iframe
              src={mapUrl}
              style={{ height: '100%', width: '100%', border: 'none' }}
              title="Map"
            />
          </View>
          </TouchableOpacity>
           <View style={{ height: 20 }} />

          </View>
        );
      })}


     
    </View>


        {/* Footer */}
        <Footer navigation={navigation} />
      </View>
      </ScrollView>
    </View>
  );
};


export default Contact;
